import {Directive, EventEmitter, HostBinding, HostListener, Output} from '@angular/core';

@Directive({
    selector: '[appDnd]',
    standalone: false
})
export class DndDirective {
  @HostBinding('class.allowedfileover') allowedFileOver: boolean;
  @HostBinding('class.forbiddenfileover') forbiddenFileOver: boolean;
  @Output() fileDropped: EventEmitter<FileList> = new EventEmitter<FileList>();

  // Dragover listener
  @HostListener('dragover', ['$event']) onDragOver(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    const isAllowedFile = evt.dataTransfer.items.length === 1;
    this.allowedFileOver = isAllowedFile;
    this.forbiddenFileOver = !isAllowedFile;
  }

  // Dragleave listener
  @HostListener('dragleave', ['$event'])
  public onDragLeave(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.allowedFileOver = false;
    this.forbiddenFileOver = false;
  }

  // Drop listener
  @HostListener('drop', ['$event'])
  public ondrop(evt): void {
    evt.preventDefault();
    evt.stopPropagation();
    this.allowedFileOver = false;
    this.forbiddenFileOver = false;
    const files: FileList = evt.dataTransfer.files;
    if (files.length > 0) {
      this.fileDropped.emit(files);
    }
  }
}
